module.exports = __webpack_public_path__ + "static/img/12.17ecaaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/12.png
// module id = 0FmX
// module chunks = 35